/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';
import { ServiceError } from '../../services/service_base';

export const initialState = Immutable.fromJS({
  tackInterval: undefined,
  isCorrect: undefined,
  isTackDone: undefined,
  tackSlug: undefined,
  language: undefined,
  correctWordText: undefined,
  loading: false,
  error: undefined
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.TACK_INTERVAL_SELECTION_RESET:
      return initialState;
    case types.TACK_INTERVAL_SELECTION_LOADING:
      return state.merge({ loading: true });
    case types.TACK_INTERVAL_SELECTION_SELECTED:
      return state.merge({ ...action.tackIntervalSelection, loading: false });
    case types.TACK_INTERVAL_SELECTION_ERROR:
      const error = (action.error instanceof ServiceError) ? action.error.message : action.error;
      return state.merge({ error: error, loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack_interval_selections/reducer.js